// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ImageSlider-module--wrap--3N5Bs","imageBackup":"ImageSlider-module--imageBackup--20Bdg"};